var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77762 12.4424C2.8296 10.7893 2.37185 9.43948 2.09584 8.07121C1.68762 6.04758 2.62181 4.07081 4.16938 2.80947C4.82345 2.27638 5.57323 2.45852 5.96 3.1524L6.83318 4.71891C7.52529 5.96056 7.87134 6.58139 7.8027 7.23959C7.73406 7.89779 7.26737 8.43386 6.33397 9.506L3.77762 12.4424ZM3.77762 12.4424C5.69651 15.7883 8.70784 18.8013 12.0576 20.7224M12.0576 20.7224C13.7107 21.6704 15.0605 22.1281 16.4288 22.4042C18.4524 22.8124 20.4292 21.8782 21.6905 20.3306C22.2236 19.6766 22.0415 18.9268 21.3476 18.54L19.7811 17.6668C18.5394 16.9747 17.9186 16.6287 17.2604 16.6973C16.6022 16.7659 16.0661 17.2326 14.994 18.166L12.0576 20.7224Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H12.8571C13.2612 7.5 13.4632 7.5 13.5888 7.62204C13.7143 7.74408 13.7143 7.9405 13.7143 8.33333C13.7143 9.11901 13.7143 9.51184 13.4632 9.75592C13.2723 9.94155 12.9929 9.986 12.5145 9.99665C12.2692 10.0021 12.1465 10.0048 12.0732 10.0777C12 10.1506 12 10.267 12 10.5V11.6667C12 12.0595 12 12.2559 12.1255 12.378C12.2511 12.5 12.4531 12.5 12.8571 12.5H13.7143M18 7.5V10M18 10H16.5429C16.2196 10 16.058 10 15.9576 9.90237C15.8571 9.80474 15.8571 9.6476 15.8571 9.33333V7.5M18 10V12.5",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.80518C10.089 4.70518 10.1815 4.60717 10.2774 4.51129C12.9591 1.82957 17.307 1.82957 19.9887 4.51129C22.6704 7.193 22.6704 11.5409 19.9887 14.2226C19.8928 14.3185 19.7948 14.411 19.6948 14.5",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7fce4b7816a91b27d4fcc11924d9d4e2.svg";
export { ForwardRef as ReactComponent };